import React from "react"

import {LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarInsertMenu from "./write-with-ai-chat"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import {EditorAIOptions} from "../../../../editor";
import {featureAccess} from "../../../../../../gd/access-control/feature-access/feature-access";
import {Feature} from "../../../../../../gd/access-control/feature-access/const";

type Props = {
    editor  : LexicalEditor

    ai?     : EditorAIOptions
}

// const debug = "WriteWithAiToolbar"
const debug = false

export default function WriteWithAiToolbar(props: Props): JSX.Element | null {

    if (props.ai?.disabled) {
        return null
    }

    return (
        <PopupMenuButton
            hint                = "Write with AI"
            btnComponent        = {(state:any,props:any) => {
                return <ControlButtonStandard iconClass="i5-default-ai fs-16"/>
            }}
            attachmentType      = "horizontal"
            attachment          = "top left"
            targetAttachment    = "bottom left"
            offset              = "0 6"
            menuComponent       = {ToolbarInsertMenu}
            menuParams          = {{
                editor  : props.editor,
                ai      : props.ai
            }}
        />
    )
}